module.exports = __webpack_public_path__ + "img/pointed.5f313a57.png";